<template>
  <div class="contratar-page">
    <div class="contratar-topo">
      <router-link to="/" class="contratar-logo-link">
        <img src="@/assets/logoInteliteAzul.png" alt="Intelite" class="contratar-logo">
      </router-link>
      <img src="@/assets/logo.png" alt="Avalize" class="contratar-logo-avalize">
    </div>

    <v-container fluid class="contratar-container">
      <v-row justify="center">
        <v-col cols="12" sm="11" md="9" lg="7">

          <div v-if="!autocontratacaoAtiva" class="av-card av-panel contratar-card">
            <h1 class="av-dialog-title">Contratação indisponível</h1>
            <p class="av-page-subtitle mb-4">No momento não estamos aceitando novas contratações por aqui. Entre em contato conosco para mais informações.</p>
            <v-btn depressed color="primary" @click="$router.push('/')">Voltar para o início</v-btn>
          </div>

          <div v-else-if="planoErro" class="av-card av-panel contratar-card">
            <h1 class="av-dialog-title">Link inválido</h1>
            <p class="av-page-subtitle mb-4">Este link de contratação não é válido ou o plano não está mais disponível.</p>
            <v-btn depressed color="primary" @click="$router.push('/')">Voltar para o início</v-btn>
          </div>

          <template v-else>
            <v-chip outlined color="primary" class="contratar-voltar" @click="$router.push('/')">
              <v-icon left small>mdi-arrow-left</v-icon>
              Voltar
            </v-chip>

            <div v-if="plano" class="contratar-plano">
              <div>
                <span class="contratar-plano-nome">Plano {{ plano.nome }}</span>
                <p class="contratar-plano-desc">Tudo que você precisa para medir e melhorar a satisfação dos seus clientes.</p>
              </div>
              <span class="contratar-plano-valor">R$ {{ valorFormatado }}<small>/mês</small></span>
            </div>

            <div class="av-card av-panel contratar-card">
              <v-stepper v-model="etapa" flat class="av-stepper">
                <v-stepper-header>
                  <v-stepper-step :complete="etapa > 1" step="1">Dados de cadastro</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2">Acesso liberado</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <div class="av-step-body">
                      <p class="av-dialog-hint">* indica preenchimento obrigatório</p>

                      <v-form ref="form" v-model="formValido">
                        <span class="av-section-label">Dados da empresa</span>
                        <v-row class="av-form-row">
                          <v-col cols="12">
                            <label class="av-field-label">Nome da empresa <span class="req">*</span></label>
                            <v-text-field
                              outlined dense hide-details="auto"
                              v-model="form.nomeEmpresa"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <label class="av-field-label">CNPJ <span class="req">*</span></label>
                            <v-text-field
                              v-mask="'##.###.###/####-##'"
                              outlined dense hide-details="auto"
                              v-model="form.cnpj"
                              :rules="[rules.required, rules.cnpj]"
                              :error-messages="erroCnpj ? [erroCnpj] : []"
                              @input="erroCnpj = ''"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <label class="av-field-label">Telefone <span class="req">*</span></label>
                            <v-text-field
                              outlined dense hide-details="auto"
                              maxlength="15"
                              :value="form.telefone"
                              @input="onTelefoneInput"
                              :rules="[rules.required, rules.telefone]"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-divider class="av-form-divider"></v-divider>

                        <span class="av-section-label">Dados do responsável</span>
                        <v-row class="av-form-row">
                          <v-col cols="12" sm="6">
                            <label class="av-field-label">Seu nome <span class="req">*</span></label>
                            <v-text-field
                              outlined dense hide-details="auto"
                              v-model="form.nomeResponsavel"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <label class="av-field-label">Seu e-mail <span class="req">*</span></label>
                            <v-text-field
                              outlined dense hide-details="auto"
                              v-model="form.emailResponsavel"
                              :rules="[rules.required, rules.email]"
                              :error-messages="erroEmail ? [erroEmail] : []"
                              @input="erroEmail = ''"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <template v-if="captchaPergunta">
                          <v-divider class="av-form-divider"></v-divider>
                          <span class="av-section-label">Verificação</span>
                          <v-row class="av-form-row">
                            <v-col cols="12" sm="6">
                              <label class="av-field-label">{{ captchaPergunta }} <span class="req">*</span></label>
                              <v-text-field
                                outlined dense hide-details="auto"
                                type="number"
                                v-model="captchaResposta"
                                :rules="[rules.required]"
                                :error-messages="erroCaptcha ? [erroCaptcha] : []"
                                @input="erroCaptcha = ''"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                      </v-form>
                    </div>

                    <div class="av-step-actions">
                      <v-btn block depressed color="primary" @click="enviar">Criar minha conta</v-btn>
                    </div>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <div class="av-step-body contratar-sucesso" v-if="sucesso">
                      <div class="contratar-sucesso-icone">
                        <v-icon color="success" size="48">mdi-check-circle</v-icon>
                      </div>
                      <h2 class="contratar-sucesso-titulo">Conta criada com sucesso!</h2>
                      <p class="av-page-subtitle contratar-sucesso-subtitulo">Anote sua senha de acesso abaixo — também enviamos para o seu e-mail:</p>

                      <div class="contratar-credenciais">
                        <div class="contratar-credencial-item">
                          <v-icon color="primary">mdi-email-outline</v-icon>
                          <div class="contratar-credencial-texto">
                            <span class="contratar-credencial-label">E-mail</span>
                            <span class="contratar-credencial-valor">{{ sucesso.email }}</span>
                          </div>
                        </div>
                        <v-divider class="my-3"></v-divider>
                        <div class="contratar-credencial-item">
                          <v-icon color="primary">mdi-lock-outline</v-icon>
                          <div class="contratar-credencial-texto">
                            <span class="contratar-credencial-label">Senha</span>
                            <span class="contratar-credencial-valor">{{ sucesso.senha }}</span>
                          </div>
                          <v-spacer></v-spacer>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon small v-on="on" @click="copiarSenha">
                                <v-icon small>mdi-content-copy</v-icon>
                              </v-btn>
                            </template>
                            <span>Copiar senha</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </div>
                    <div class="av-step-actions">
                      <v-btn block depressed color="primary" @click="irParaLogin">Ir para o login</v-btn>
                    </div>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
          </template>

        </v-col>
      </v-row>
    </v-container>

    <Snackbar ref="chamaSnackbar" />
    <loading :active.sync="isLoading" :can-cancel="false" color="#2f7d74" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global';
  import Snackbar from '../../componentes/snackbar.vue';
  import axios from 'axios';

  function validarCNPJ(cnpj) {
    const digitos = String(cnpj || '').replace(/\D/g, '');
    if (digitos.length !== 14) return false;
    if (/^(\d)\1{13}$/.test(digitos)) return false;

    const numeros = digitos.split('').map(Number);

    const calcularDigito = (base, pesos) => {
      const soma = base.reduce((acc, digito, i) => acc + digito * pesos[i], 0);
      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };

    const dv1 = calcularDigito(numeros.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    if (dv1 !== numeros[12]) return false;

    const dv2 = calcularDigito(numeros.slice(0, 13), [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
    if (dv2 !== numeros[13]) return false;

    return true;
  }

  // Formata o telefone a partir da contagem real de dígitos: usa o
  // agrupamento de fixo (4+4) por padrão e só passa para o de celular (5+4)
  // quando o 11º dígito é digitado — e volta para 4+4 se ele for apagado,
  // já que a máscara é recalculada do zero a cada tecla.
  function formatarTelefone(valorBruto) {
    const digitos = String(valorBruto || '').replace(/\D/g, '').slice(0, 11);
    if (!digitos) return '';
    if (digitos.length <= 2) return '(' + digitos + (digitos.length === 2 ? ') ' : '');

    const ddd = digitos.slice(0, 2);
    const resto = digitos.slice(2);

    if (resto.length <= 4) {
      return '(' + ddd + ') ' + resto;
    }

    if (digitos.length <= 10) {
      return '(' + ddd + ') ' + resto.slice(0, 4) + '-' + resto.slice(4);
    }

    return '(' + ddd + ') ' + resto.slice(0, 5) + '-' + resto.slice(5);
  }

  export default {
    components: { Snackbar, Loading },

    data() {
      return {
        isLoading: false,
        fullPage: true,
        etapa: 1,
        autocontratacaoAtiva: false,
        planoSlug: '',
        plano: null,
        planoErro: false,
        captchaToken: '',
        captchaPergunta: '',
        captchaResposta: '',
        erroCaptcha: '',
        sucesso: null,
        formValido: true,
        erroCnpj: '',
        erroEmail: '',
        rules: {
          required: v => !!v || 'Campo obrigatório',
          cnpj: v => validarCNPJ(v) || 'CNPJ inválido',
          telefone: v => /^\(\d{2}\) \d{4,5}-\d{4}$/.test(v || '') || 'Telefone inválido',
          email: v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '') || 'E-mail inválido',
        },
        form: {
          nomeEmpresa: '',
          cnpj: '',
          telefone: '',
          nomeResponsavel: '',
          emailResponsavel: '',
        },
      };
    },

    computed: {
      valorFormatado() {
        if (!this.plano) return '';
        return Number(this.plano.valorMensal).toFixed(2).replace('.', ',');
      },
    },

    async mounted() {
      this.planoSlug = this.$route.params.planoSlug || 'padrao';
      await this.carregarConfiguracao();
      if (this.autocontratacaoAtiva) {
        this.carregarPlano();
        this.carregarCaptcha();
      }
    },

    methods: {
      async carregarConfiguracao() {
        await axios.get(baseApiUrl + 'Configuracoes/info')
          .then(response => {
            this.autocontratacaoAtiva = !!(response.data && response.data.autocontratacao === true);
          })
          .catch(() => {
            this.autocontratacaoAtiva = false;
          });
      },

      async carregarPlano() {
        this.isLoading = true;
        const filtro = encodeURIComponent(JSON.stringify({ where: { slug: this.planoSlug, ativo: true } }));
        await axios.get(baseApiUrl + 'Planos/findOne?filter=' + filtro)
          .then(response => {
            if (response.data) {
              this.plano = response.data;
              this.planoErro = false;
            } else {
              this.planoErro = true;
            }
          })
          .catch(() => {
            this.planoErro = true;
          });
        this.isLoading = false;
      },

      async carregarCaptcha() {
        await axios.get(baseApiUrl + 'Contratacoes/gerarCaptcha')
          .then(response => {
            this.captchaToken = response.data.token;
            this.captchaPergunta = response.data.pergunta;
          })
          .catch(() => {
            this.captchaPergunta = '';
          });
        this.captchaResposta = '';
      },

      onTelefoneInput(valor) {
        this.form.telefone = formatarTelefone(valor);
      },

      async enviar() {
        var vm = this;
        this.erroCnpj = '';
        this.erroEmail = '';
        this.erroCaptcha = '';

        if (!this.$refs.form.validate()) {
          return;
        }

        this.isLoading = true;
        await axios.post(baseApiUrl + 'Contratacoes/criar', {
          nomeEmpresa: this.form.nomeEmpresa,
          cnpj: this.form.cnpj,
          telefone: this.form.telefone,
          nomeResponsavel: this.form.nomeResponsavel,
          emailResponsavel: this.form.emailResponsavel,
          planoSlug: this.planoSlug,
          captchaToken: this.captchaToken,
          captchaResposta: this.captchaResposta,
        })
          .then(response => {
            this.sucesso = response.data;
            this.etapa = 2;
          })
          .catch(erro => {
            const mensagem = (erro.response && erro.response.data && erro.response.data.error && erro.response.data.error.message)
              || 'Erro ao processar a contratação';

            if (/cnpj/i.test(mensagem)) {
              vm.erroCnpj = mensagem;
            } else if (/e-mail/i.test(mensagem)) {
              vm.erroEmail = mensagem;
            } else if (/verifica|resposta/i.test(mensagem)) {
              vm.erroCaptcha = mensagem;
            } else {
              vm.$refs.chamaSnackbar.snack("#FEC8C8", mensagem, "#BF4554");
            }

            vm.carregarCaptcha();
          });
        this.isLoading = false;
      },

      irParaLogin() {
        this.$router.push('/login');
      },

      copiarSenha() {
        var vm = this;
        navigator.clipboard.writeText(this.sucesso.senha).then(() => {
          vm.$refs.chamaSnackbar.snack("success", "Senha copiada!", "white");
        });
      },
    },
  };
</script>

<style scoped>
  .contratar-page {
    min-height: 100vh;
    background: var(--av-bg);
  }

  .contratar-topo {
    padding: 24px 24px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }

  .contratar-logo {
    height: 40px;
  }

  .contratar-logo-avalize {
    height: 40px;
  }

  .contratar-container {
    padding: 24px 16px 48px;
  }

  .contratar-voltar {
    margin-bottom: 12px;
    font-weight: 500;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .contratar-card {
    padding: 16px 24px 8px;
  }

  .contratar-plano {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: var(--av-surface);
    border: 1px solid var(--av-primary);
    border-radius: var(--av-radius);
    box-shadow: var(--av-shadow);
    padding: 16px 20px;
    margin-bottom: 16px;
  }

  .contratar-plano-nome {
    font-weight: 700;
    color: var(--av-text);
  }

  .contratar-plano-desc {
    margin: 4px 0 0;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .contratar-plano-valor {
    font-weight: 700;
    color: var(--av-primary);
    font-size: 22px;
    white-space: nowrap;
  }

  .contratar-plano-valor small {
    font-size: 12px;
    font-weight: 500;
    color: var(--av-text-soft);
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0 0 16px;
    padding: 0;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin: 4px 0 10px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  .av-form-divider {
    margin: 20px 0;
  }

  .contratar-sucesso {
    text-align: center;
  }

  .contratar-sucesso-icone {
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
  }

  .contratar-sucesso-titulo {
    font-size: 22px;
    font-weight: 700;
    color: var(--av-text);
    margin: 0 0 6px;
  }

  .contratar-sucesso-subtitulo {
    max-width: 420px;
    margin: 0 auto 20px;
  }

  ::v-deep .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  ::v-deep .av-stepper.v-stepper {
    box-shadow: none;
  }

  ::v-deep .av-stepper .v-stepper__header {
    box-shadow: none;
  }

  ::v-deep .av-stepper .v-stepper__content {
    padding: 16px 4px 0;
  }

  .av-step-body {
    min-height: 120px;
    padding-bottom: 8px;
  }

  .av-step-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    border-top: 1px solid var(--av-border);
    padding-top: 12px;
    margin-top: 8px;
  }

  .contratar-credenciais {
    background: var(--av-bg);
    border: 1px solid var(--av-border);
    border-radius: var(--av-radius);
    padding: 16px 20px;
    margin: 0 0 20px;
    text-align: left;
  }

  .contratar-credencial-item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .contratar-credencial-texto {
    display: flex;
    flex-direction: column;
  }

  .contratar-credencial-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
  }

  .contratar-credencial-valor {
    font-size: 15px;
    font-weight: 600;
    color: var(--av-text);
  }
</style>
